import React, { Component } from "react";
import style from "./PermitsUpload.module.css";
import api from "../../utils/Api";

export class PermitsUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputList: [
        {
          selectedFile: "",
          document_type: "",
          description: "",
          isNewUpload: true,
          delete: 0,
        },
      ],
      imageErr: "",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const permitUploadDocs = this.props.dataFromParent;
      // console.log("******** permitUploadDocs *********", permitUploadDocs);
      const list = permitUploadDocs.map((item) => ({
        ...item,
        isNewUpload: false,
        delete: 0,
        description: item.description?item.description:"",
        document_type: item.document_type?item.document_type:"",
        selectedFile: item.file_name,
      }));
      if (permitUploadDocs) {
        this.setState({
          inputList: list,
        });
      }
    }, 200);
  }

  handleInputChangeFile = (event, index) => {
    const { name, files } = event.target;

    if (files && files[0]) {
      var FileSize = files && files[0].size / 1024 / 1024; // in MB

      if (/\.(jpe?g|png|svg|pdf)$/i.test(files && files[0].name) === false) {
        this.setState({
          imageErr: "This type of file extension is not allowed",
        });
        let uploadflag = true;
        this.props.getImageError(uploadflag);
      } else {
          if (FileSize > 2.0) {
            this.setState({
              imageErr: "Please upload file less than 2MB!",
            });
          } else {
            this.setState({
              imageErr: "",
            });
            let uploadflag = false;
            const list = [...this.state.inputList];
            list[index][name] = files[0];
            list[index].isNewUpload = true;
            list[index].delete = 0;
            // setInputList(list);
            // const { name, files } = e.target;
            // const name = event.target;
            // const files = event.target;
            // const list = [...this.state.inputList];
            // list[index][name] = files[0];
            // list[index].isNewUpload = true;
            // list[index].delete = 0;
            this.setState({
              inputList: list,
            });
            this.props.getPermitsProof(list);
            this.props.getImageError(uploadflag);
          }
      }
    }
  };

  handleInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    const list = [...this.state.inputList];
    list[index][name] = val;
    this.setState({
      inputList: list,
    });
    this.props.getPermitsProof(list);
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    if (list[index].isNewUpload) {
      list.splice(index, 1);
    } else if(list[index].selectedFile === ""){
      list.splice(index, 1)
    }
    else {
      list[index].delete = true;
    }

    this.setState({
      inputList: list,
    });
    this.props.getPermitsProof(list);
  };

  handleAddClick = () => {
    this.setState((prevState) => ({
      inputList: [
        ...this.state.inputList,
        {
          selectedFile: "",
          document_type: "",
          description: "",
        },
      ],
    }));
  };

  // downloadDocuments = (attachment_id) => {
  //   alert(attachment_id);
  // };

  // API calls for download invoice details
  downloadDocuments = async (attachment_id, file_name) => {
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    // const payload = {
    //   attachment_id: attachment_id,
    // };

    try {
      // const response = await api.get(`attachment/${attachment_id}`, {
      //   headers: headers,
      //   responseType: "blob",
      // });
      const response = await api.get("attachment/" + attachment_id, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${file_name}`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  render() {
    return (
      <div className={style.uloadDocMainWrapper}>
        <div className="form-box-shadow mt-4">
          <div className={`row mb-3`}>
            <div className="col-sm-6 mb-3">
              <h4 className="mb-1"> Certificates and Permits :</h4>
              <small>{`Allowed extensions are .pdf, .jpg, .png, .svg and max limit size is 2MB.`}</small>
            </div>
            <div className="col-sm-6 text-center text-sm-right mb-3 mb-sm-2">
              <button
                type="button"
                onClick={this.handleAddClick}
                className="ttm-secondary-btn tmed-secondary-btn"
              >
                <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                Add
              </button>
            </div>
          </div>

          <div
            className={`form-controls-wrapper ${style.uploadDocFormWrapper}`}
          >
            {this.state.inputList &&
              this.state.inputList.map((x, i) => {
                return (
                  !x.delete && (
                    <div className="box" key={i}>
                      <div className={`row ${style.mobileUploadDeocWrapper}`}>
                        <div className="col-8 col-sm-6 col-md-3 col-lg-3">
                         {!x.selectedFile && !x.selectedFile.name && (
                          <div className="form-group">
                            <div className={style.uploadBtnWrapper}>
                              <button type="button" className={style.uploadBtn}>
                                <i
                                  className="fa fa-upload mr-2"
                                  aria-hidden="true"
                                ></i>{" "}
                                Upload
                              </button>
                              <input
                                type="file"
                                name="selectedFile"
                                // onChange={(e) => handleInputChangeFile(e, i)}
                                onChange={(e) =>
                                  this.handleInputChangeFile(e, i)
                                }
                                title={
                                  x.selectedFile
                                    ? x.selectedFile.name
                                    : x.selectedFile
                                }
                              />
                            </div>
                          </div>)}
                        {/* </div>

                        <div className="order-3 order-sm-3 order-md-2 col-sm-12 col-md-3 col-lg-3"> */}
                          { (x.selectedFile || (x.isNewUpload && x.selectedFile && x.selectedFile.name)) && (
                          <div className={`form-group ${style.uploadedText}`}>
                            {x.isNewUpload && x.selectedFile
                              ? x.selectedFile.name
                              : x.selectedFile}{" "}
                            {x.isNewUpload == false && (
                              <i
                                onClick={() =>
                                  this.downloadDocuments(
                                    this.state.inputList[i].attachment_id,
                                    x.file_name
                                  )
                                }
                                class={`fa fa-download ${style.downloadIc}`}
                                aria-hidden="true"
                              ></i>
                            )}
                          </div>)}
                        </div>

                        {/* {x.isNewUpload === false && (
                      <div className="order-3 order-sm-3 order-md-2 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                        <div className={`form-group ${style.uploadedText}`}>
                          {x.file_name}
                        </div>
                      </div>
                    )} */}

                        <div className="order-4 order-sm-4 order-md-4 col-sm-12 col-md-5 col-lg-5">
                          <div className="form-group">
                            <input
                              className={`form-control ${style.description}`}
                              name="description"
                              placeholder="Description"
                              value={x.description}
                              // onChange={(e) => handleInputChange(e, i)}
                              onChange={(e) => this.handleInputChange(e, i)}
                            />
                          </div>
                        </div>
                        <div className="order-3 order-sm-3 order-md-3 col-sm-12 col-md-3 col-lg-3">
                          <div className="form-group">
                            <select
                              name="document_type"
                              id="document_type"
                              className="form-control"
                              // onChange={(e) => handleInputChange(e, i)}
                              onChange={(e) => this.handleInputChange(e, i)}
                              value={x.document_type}
                            >
                              <option value="">Document Type</option>
                              <option value="1">Legal</option>
                              <option value="2">Tax Compliance</option>
                              <option value="3">Affiliations</option>
                              <option value="4">Contracts</option>
                              <option value="5">Consents</option>
                            </select>
                          </div>
                        </div>
                        <div
                          className={`oder-2 oder-sm-2 order-md-4 col-4 col-sm-6 col-md-1 col-lg-1 ${style.pullRightIcon}`}
                        >
                          {this.state.inputList &&
                            this.state.inputList.length > 0 && (
                              <i
                                className={`fa fa-times ${style.deleteIcon}`}
                                aria-hidden="true"
                                onClick={() => this.handleRemoveClick(i)}
                              ></i>
                            )}
                        </div>
                        {/* <div className="order-5 order-sm-5 order-md-5 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                          {this.state.inputList &&
                            this.state.inputList.length - 1 === i && (
                              <button
                                onClick={this.handleAddClick}
                                className="ttm-secondary-btn tmed-secondary-btn"
                              >
                                <i
                                  className="fa fa-plus mr-2"
                                  aria-hidden="true"
                                ></i>
                                Add
                              </button>
                            )}
                        </div> */}
                      </div>
                    </div>
                  )
                );
              })}
            {/* <div style={{ marginTop: 20 }}>
              {JSON.stringify(this.state.inputList)}
            </div> */}
          </div>
          <span className="error">
            {this.state.imageErr ? this.state.imageErr : ""}
          </span>
        </div>
      </div>
    );
  }
}

export default PermitsUpload;
